import { Tag } from "../Tag";
import { useEffect, useContext, useRef } from "preact/hooks";

import { mainCategories } from "../static-data";
import { Context } from "../Context";

import style from "./CategoryFilter.css";
import {
  handleDropdownClose,
  handleDropdownOpen,
  isMobileScreen,
  getCategoryTitleWithKey,
} from "../../helpers";

const CategoryFilter = ({
  categoryFilter,
  onSetCategoryFilter,
  onBreakingChange,
}) => {
  const [context, setContext] = useContext(Context);
  const node = useRef();

  // useEffect(() => {
  //   window.addEventListener("popstate", handlePop);
  //   return () => {
  //     document.removeEventListener("popstate", handlePop);
  //   };
  // }, []);

  // const handlePop = (event) => {
  //   if (window.location.search.indexOf("catOpen") >= 0) {
  //     setContext({ ...context, filterOpen: "catOpen" });
  //   } else {
  //     if (window.location.search.indexOf("catOpen") < 0) {
  //       setContext({ ...context, filterOpen: "" });
  //     }
  //   }
  // };

  const renderListItemStyle = (key) =>
    key === categoryFilter
      ? style.selectedCategoryListItem
      : style.categoryListItem;

  const handleCategorySelected = (newCategoryKey) => {
    if (newCategoryKey === categoryFilter) {
      onSetCategoryFilter("");
    } else {
      onBreakingChange(true);
      onSetCategoryFilter(newCategoryKey);
    }
  };

  const conditionalMobileHeader = () => {
    if (!isMobileScreen()) return null;

    return (
      <div class={style.mobileCategoryHeader}>
        <div class={style.closeIcon} onClick={handleCategoryFilterClose}></div>
        <h4>Kategorien</h4>
        <div class={style.hidden}>x</div>
      </div>
    );
  };

  const conditionalRenderCategoryDropdown = () => {
    if (context.filterOpen === "catOpen")
      return (
        <div
          class={style.categoryFilter}
          onClick={() => {
            if (!isMobileScreen()) {
              handleCategoryFilterClose();
            }
          }}
        >
          <div
            class={style.categoryFilterContainer}
            style={{
              left: node.current.base.getBoundingClientRect().left + "px",
              top: node.current.base.getBoundingClientRect().top + "px",
            }}
          >
            {conditionalMobileHeader()}
            <div class={style.categoryListContainer}>
              <ul class={style.categoryUl}>
                {mainCategories.map((category) => (
                  <li
                    key={category.key}
                    class={renderListItemStyle(category.key)}
                    onClick={() => {
                      handleCategorySelected(category.key);
                      handleCategoryFilterClose();
                    }}
                  >
                    {category.title}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      );
  };

  const handleCategoryFilterOpen = () => {
    handleDropdownOpen("catOpen");
    setContext({ ...context, filterOpen: "catOpen" });
  };

  const handleCategoryFilterClose = () => {
    handleDropdownClose("catOpen");
    setContext({ ...context, filterOpen: "" });
  };

  return (
    <Fragment>
      <Tag
        ref={node}
        id="mapCategoryFilter"
        text={getCategoryTitleWithKey(categoryFilter)}
        selected={categoryFilter && categoryFilter.length !== 0}
        onClick={handleCategoryFilterOpen}
        hasDropdown={true}
      />

      {conditionalRenderCategoryDropdown()}
    </Fragment>
  );
};

export { CategoryFilter };
